import { container } from '../../utils/container/container';
import { ServiceIds } from '../../utils/container/service-ids';
import { GoogleSignIn } from './google-sign-in';

export function getGoogleSignIn(): GoogleSignIn {
    if (container.isBound(ServiceIds.GOOGLE_SIGN_IN)) {
        return container.get<GoogleSignIn>(ServiceIds.GOOGLE_SIGN_IN);
    }

    const adapter = new GoogleSignIn(window.app.config.google);
    container.bind(ServiceIds.GOOGLE_SIGN_IN).toConstantValue(adapter);
    return adapter;
}
